import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import uuid from "uuid/v4";
import Tooltip from "@material-ui/core/Tooltip";
import s from "./ChatList.module.scss";

class RefreshEmailLogItem extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.state = {
      currentid: "",
      id: "",
    };
  }

  componentDidMount() {
    this.setState({
      currentid: parseInt(this.props.currentid),
      id: this.props.id,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentid !== this.props.currentid) {
      this.setState({
        currentid: parseInt(this.props.currentid),
        id: this.props.id,
      });
    }
  }

  render() {
    const { isActive, report } = this.props;
    const { currentid, id } = this.state;
    return (
      <li
        ref={this.scrollRef}
        onClick={(e) => this.props.setCurrentRefreshLog(report.id)}
        className={`${s.chatListItem} ${id === currentid ? s.active : ""}`}
      >
        <div className={`${s.chatListItemWrapper}`}>
          <ul className={s.avatarsColumn}></ul>

          <section id={report.id} className={`${s.chatItemMain} ml-3`}>
            <header className="d-flex align-items-center justify-content-between mb-1">
              <h6 className={`${s.chatTitle}`}>{report.template.name}</h6>
              <span className={`ml-auto ${s.timestamp}`}></span>
            </header>
            <p className={`${s.chatLastMessage}`}>
              <ul>
                <li>
                  {" "}
                  <span className={`${s.ownerIndicator} emailreportdesc mr-1`}>
                    Date Sent:{" "}
                  </span>
                  {moment(report.datesent, "YYYY-MM-DD hh:mm:ss").format(
                    "MMM DD, YYYY"
                  )}
                </li>
                <li>
                  {" "}
                  <span className={`${s.ownerIndicator} emailreportdesc mr-1`}>
                    # Recipients:{" "}
                  </span>
                  {report.recipients.length}
                </li>
                <li>
                  {" "}
                  <span className={`${s.ownerIndicator} emailreportdesc mr-1`}>
                    Follow-ups Completed:{" "}
                  </span>
                  {report.followupcompleted.length}
                </li>
              </ul>
            </p>
          </section>
        </div>
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(RefreshEmailLogItem);
